import { getState, setState, subscribe } from '@/store';
import type { ProfilesState } from '@/types';
import { PL_LOG_GROUPS, logger } from '@/utils';
import { LOG_LEVEL, deeplyEqual } from '@b2x/shared';
import { getDispatchers, subscribe as subscribeToOneContext } from '@seamless/one-context';

export async function handleOneContext() {
  const dispatchers = await getDispatchers('iam', 'ProfileConnection');

  if (!dispatchers.setProfileState) {
    return;
  }

  logger('🚨 Using version of one context incompatible with PLv3!', {
    level: LOG_LEVEL.WARN,
    group: PL_LOG_GROUPS.LEGACY,
  });

  // Helper to extract only the shared keys, removing derived values
  function getComparableState(state: any) {
    const { activeProfile, availableProfiles, meta } = state || {};
    return { activeProfile, availableProfiles, meta };
  }

  let lastOneContextState: any = null;

  subscribeToOneContext('ProfileConnection', {
    tenant: 'iam',
    componentName: 'PL',
    callback: async (state) => {
      const currentState = getComparableState(getState());
      const incomingState = getComparableState(state);
      if (deeplyEqual(currentState, incomingState)) {
        return;
      }
      lastOneContextState = incomingState;
      setState(state as ProfilesState);
    },
  });

  subscribe((state) => {
    const comparableState = getComparableState(state);
    if (deeplyEqual(comparableState, lastOneContextState)) {
      return;
    }
    lastOneContextState = comparableState;
    dispatchers.setProfileState(comparableState);
  });
}
